/**
 * Loom – Screen Recorder & Screen Capture
 *
 * Exposes 64 static resources to every origin — one of the broadest surfaces in the
 * top 20. The recording bubble and permissions check are both stably named.
 *
 * Manifest verified against version 5.5.200.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'liecbddmkiiihnedobmlmillhodjkdmb';

export const loom: ExtensionDefinition = {
  id: ID,
  name: 'Loom – Screen Recorder & Screen Capture',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 7_000_000,
  notes: '64 static web-accessible resources exposed to <all_urls>.',
  signals: [
    {
      id: 'war-bubble-html',
      kind: 'web-accessible-resource',
      description:
        'Fetch html/bubble.html — the recording-control bubble overlaid on the page.',
      weight: 1,
      run: () => probeFetch(ID, 'html/bubble.html'),
    },
    {
      id: 'war-permissions-check',
      kind: 'web-accessible-resource',
      description: 'Fetch html/permissionsCheck.html — the camera/mic permission probe UI.',
      weight: 0.5,
      run: () => probeFetch(ID, 'html/permissionsCheck.html'),
    },
  ],
};
